import { render } from "./NgxFilings.vue?vue&type=template&id=7c753958&scoped=true"
import script from "./NgxFilings.vue?vue&type=script&lang=js"
export * from "./NgxFilings.vue?vue&type=script&lang=js"

import "./NgxFilings.vue?vue&type=style&index=0&id=7c753958&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c753958"]])

export default __exports__